// extracted by mini-css-extract-plugin
module.exports = {"gutter":"16px","bg":"#f0f2f5","menuBg":"#f0f5ff","menuHover":"#f0f5ff","menuOpenedBg":"#f0f5ff","sideBarWidth":"232px"};